import { LoadableLazy } from '@confluence/loadable';

export const ContextualCreateContentPopoverMenuLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContextualCreateContentPopoverMenu" */ './ContextualCreateContentPopoverMenu'
			)
		).ContextualCreateContentPopoverMenu,
});
